export default {
    methods: {
        makeImageLink(accountHash, imageId, variant) {
            if (process.env.NODE_ENV === 'development') {
                return `https://octomated.com/cdn-cgi/imagedelivery/${accountHash}/${imageId}/${variant}`;
            }
            return `/cdn-cgi/imagedelivery/${accountHash}/${imageId}/${variant}`;
        },
    },
}
